import { withMotionMax } from '@hoc/withMotionMax';
import { ArrowButton } from '@stories/Components/Buttons/GeneralButton/Button';
import TestimonialCard from '@stories/Components/Cards/TestimonialCard/TestimonialCard';
import CarouselProvider from '@stories/Components/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Connected from '@stories/Components/Carousels/Carousel/Connected/Connected';
import LiveRegion from '@stories/Components/Carousels/Carousel/LiveRegion/LiveRegion';
import CarouselCount from '@stories/Components/General/CarouselCount/CarouselCount';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './TestimonialCarousel.styles';
const TestimonialCarousel = (props) => {
    if (!props.items) {
        return null;
    }
    return (React.createElement(MotionConfig, { transition: { duration: 0.45, ease: 'easeOut' } },
        React.createElement(CarouselProvider, { count: props.items.length, pageChildren: 1 },
            React.createElement(S.Container, { variant: "dark" },
                React.createElement(S.CarouselArea, null,
                    React.createElement(LiveRegion, null),
                    React.createElement(S.Track, { trackMutations: true }, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(TestimonialCard, { ...item })))))),
                props.items.length > 1 && (React.createElement(Connected, null, (carousel) => (React.createElement(S.PaginationWrapper, null,
                    React.createElement(S.Controls, { wrap: props.wrap, renderPrev: (buttonProps) => (React.createElement(ArrowButton, { "aria-label": "Previous", ...buttonProps })), renderNext: (buttonProps) => React.createElement(ArrowButton, { "aria-label": "Next", ...buttonProps }) }),
                    React.createElement(S.Pagination, null,
                        React.createElement(CarouselCount, { current: carousel.activeIndex + 1, total: carousel.maxIndex + 1 }))))))))));
};
export default withMotionMax(TestimonialCarousel);
